var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"surface1"},React.createElement("path",{"d":"M 44.425781 9.425781 L 40 5 L 15 30 L 40 55 L 44.425781 50.574219 L 23.851562 30 Z M 44.425781 9.425781 "})));
}

Arrow.defaultProps = {"width":"60px","height":"60px","viewBox":"0 0 60 60","version":"1.1"};

module.exports = Arrow;

Arrow.default = Arrow;
